import React, {createContext, ReactElement, useState} from 'react';
import {Toast, ToastProps} from "../components/Toast/Toast";

interface ToastContextType {
    addToast: (toast: ToastProps) => void;
}

interface Props {
    children: ReactElement;
}

export const ToastContext = createContext<ToastContextType>({} as ToastContextType);

export default function ToastProvider({children}: Props) {
    const [toast, setToast] = useState<ToastProps | null>(null);

    const addToast = (toast: ToastProps) => {
        setToast(toast);

        setTimeout(() => {
            setToast(null);
        }, 6000);
    };

    const closeToast = () => {
        setToast(null);
    };

    return (
        <ToastContext.Provider value={{addToast}}>
            {toast && <Toast open={true} type={toast.type} text={toast.text} closeToast={closeToast} />}
            {children}
        </ToastContext.Provider>
    );
}
